import { createSlice} from '@reduxjs/toolkit';
import { apiCallBegan } from './api';
import _, { method } from 'lodash';
// import moment from 'moment';

function pad(num) {
  return num < 10 ? '0' + num : num;
}
let curDate = new Date()
let formattedDate = `${curDate.getFullYear()}-${pad(curDate.getMonth() + 1)}-${pad(curDate.getDate())}`

const slice = createSlice({
  name: 'departures',
  initialState: {
    airline: '',
    list: [],
    //changed the initially loading state to true
    loading: true,
    departureDate: formattedDate,
    departureAirport: '',
    flightNumber: '',
    paxInfo: [],
    reservationInfo:[],
    emailHistory: [],
    lastFetch: null,
    statusTimestamp: null,
    sending: true,
    messageSuccess: null,
    // NOTE // a dictionary with emails as keys and rlocs and status properties (used for the status of sendEmail)
    // NOTE // emailStatus: {"test@test.com": {status: true, rloc: "XQMD5Y"}, "example@example.com": {status: false, rloc: "QXQD4Z"}}
    emailStatus: null,
    // NOTE // the same as emailStatus, but the objects have an rloc and name property
    // NOTE // textStatus: {"2088675309": {status: null, rloc: 'RC2T9', name: 'Julian Assange'}}
    textStatus: null,
    curBagPax: null,
    curBagDep: null,
    bagToDelete: null,
    sendText: null,
    textResults: null,
    history: [],
  },
  reducers: {
    setAirline: (state, action) => {
      state.airline = action.payload
    },
    // actions => action handlers
    // command - event
    departuresReceived: (state, action) => {
      state.list = action.payload;
      state.loading = false;
      state.lastFetch = Date.now();
    },

    departuresRequested: (state, action) => {
      state.loading = true;
    },

    departuresRequestFailed: (state, action) => {
      state.loading = false;
    },

    changeDepartureDate: (state, action) => {
      state.departureDate = action.payload;
    },

    changeAirport: (state, action) => {
      state.departureAirport = action.payload
    },

    changeFlight: (state, action) => {
      state.flightNumber = action.payload
    },

    // SECTION PaxList Actions
    paxInfoReceived: (state, action) => {
      let paxInfoCopy = _.cloneDeep(state.paxInfo)
      let dep = action.payload
      // NOTE // filtering out no-show pax because they want to
      if (dep.passengers) {
        dep.passengers = dep.passengers.filter(pax => pax.passengerJourneyDetail.travelStatus.noshow == false)
      }
      if (!paxInfoCopy[0]) {
        state.paxInfo.push(dep)
        state.loading = false
        state.lastFetch = Date.now()
      }
      else {
        let paxLoc = paxInfoCopy.findIndex(p => p.key === dep.key)
        if (paxLoc == -1) {
          state.paxInfo.push(dep)
          state.loading = false
          state.lastFetch = Date.now()
        }
      }
    },


    paxInfoRequested: (state, action) => {
      state.loading = true;
    },

    paxInfoRequestFailed: (state, action) => {
      state.loading = false;
    },

    reservationInfoRequested: (state, action) => {
      state.loading = true;
    },

    reservationInfoReceived: (state, action) => {
  const reservationData = action.payload?.reservationInfo;

  // If reservationInfo is missing in the payload, do nothing
  if (!reservationData) return;

  const exists = state.paxInfo.some(r => r.key === reservationData.key);

  if (!exists) {
    state.reservationInfo.push(reservationData);
    state.loading = false;
    state.lastFetch = Date.now();
  }
  },
  
    
    reservationInfoRequestFailed: (state, action) => {
      state.loading = false;
    },


    // NOTE // paxInfo wasn't changing when the departure date changes. Probably not a major issue, but not very performant
    clearPaxInfo: (state, action) => {
      state.paxInfo = []
    },

    updatePaxInfoFailed: (state, action) => {
      // if (action.payload.toLowerCase().includes('400')) {
      //   alert('Denied: Please check the authority security for this passenger')
      // }
      console.log('ERR: UPDATE PAX FAILED')
      state.loading = false
    },

    paxUpdated: (state, action) => {
      let paxInfoCopy = _.cloneDeep(state.paxInfo)

      for (let i = 0; i < paxInfoCopy.length; i++) {
        let flight = paxInfoCopy[i];
        // FIXME // Cannot read property 'findIndex' of null. Only happens on occasion for some reason. Could be a hot-reload issue. I think ternary fixed it
        const updatedPax = flight.passengers ? flight.passengers.findIndex((item) => item.passengerJourneyDetail.key === action.payload.key) : -1
        if (updatedPax !== -1) {
          state.paxInfo[i].passengers[updatedPax].passengerJourneyDetail = action.payload;
        }
      }
    },

    // !SECTION
    // SECTION Close-Flight Actions
    legStatusReceived: (state, action) => {
      state.statusTimestamp = action.payload.timestamp
    },

    loadStatusFailed: (state, action) => {
      state.loading = false
    },

    resetTextHistory: (state, action) => {
      state.history = [];
    },
    resetEmailHistory: (state, action) => {
      state.emailHistory = []
    },
    emailHistoryReceived:(state,action) =>{
      state.emailHistory = action.payload
    },
    historyFetching: (state, action) => {
      // state.loading = true;
      state.sendText = null;
    },

    startSendText: (state, action) => {
      state.textResults = 'sending'
    },

    sendTextSuccess: (state, action) => {
      state.textResults = 'success'
    },

    sendTextFailure: (state, action) => {
      state.textResults = 'failure'
    },

    historyReceived: (state, action) => {
      state.history = action.payload
    },

    historyFailure: (state, action) => {
      console.error(action.payload)
    },

    flightClosed: (state, action) => {
      let listCopy = _.cloneDeep(state.list)

      for (let i = 0; i < listCopy.length; i++) {
        const depKey = listCopy[i].flightStatusLeg.key;
        const resKey = action.payload.key

        const matchingDep = action.payload.flightLeg.departure.airport.code === listCopy[i].flightStatusLeg.flightLeg.departure.airport.code
        const matchingDepTime = action.payload.departure.estimatedTime === listCopy[i].flightStatusLeg.departure.estimatedTime
        const matchingArr = action.payload.flightLeg.arrival.airport.code === listCopy[i].flightStatusLeg.flightLeg.arrival.airport.code
        const matchingArrTime = action.payload.arrival.estimatedTime === listCopy[i].flightStatusLeg.arrival.estimatedTime
        const matchingFlightNum = action.payload.flight.flightNumber === listCopy[i].flightStatus.flightNumber

        // Sometimes Amelia generates a new key when a change is made which is why we need both options
        if ((depKey == resKey) || (matchingDep && matchingDepTime && matchingArr && matchingArrTime && matchingFlightNum)) {
          state.list[i].flightStatusLeg.flightLegStatus.closed = action.payload.flightLegStatus.closed
          state.list[i].flightStatusLeg.flightLegStatus.checkInClosed = action.payload.flightLegStatus.checkInClosed
        }
      }
    },

    flightCloseFailed: (state, action) => {
      console.log('ERR: FLIGHT CLOSE FAILED')
      state.loading = false
    },
    // !SECTION
    // SECTION Modal Actions

    sendingMessage: (state, action) => {
      state.sending = true
      state.messageSuccess = 'Sending...'
    },

    doneSendingMessage: (state, action) => {
      state.sending = false
      state.messageSuccess = null
    },

    messageSent: (state, action) => {
      state.messageSuccess = 'Message Sent!'
    },

    messageFailed: (state, action) => {
      state.messageSuccess = 'Message Failure'
    },

    // !SECTION
    // SECTION text & text status
    setTextStatus: (state, action) => {
      let paxArr = action.payload
      let textStatus = {}
      for (let i = 0; i < paxArr.length; i++) {
        const pax = paxArr[i];
        textStatus[pax.phone] = {status: null, rloc: pax.rloc, name: pax.name || ''}
      }

      state.textStatus = textStatus
    },

    resetTextStatus: (state, action) => {
      state.textStatus = null
    },

    textSuccess: (state, action) => {
      // console.log('textSuccess action.payload: ', action.payload)
      state.textStatus = action.payload
    },

    textFailure: (state, action) => {
      console.log('textFailure-payload: ', action.payload)
      let textStatusCopy = _.cloneDeep(state.textStatus)
      let textStatusKeys = Object.keys(textStatusCopy)
      // NOTE // if the text request fails, set the status of each text to false (for failure)
      for (let i = 0; i < textStatusKeys.length; i++) {
        textStatusCopy[textStatusKeys[i]].status = false
      }
      state.textStatus = textStatusCopy
    },

    // !SECTION
    // SECTION email & email status
    setEmailStatus: (state, action) => {
      let emails = action.payload
      let emailStatus = {}
      for (let i = 0; i < emails.length; i++) {
        const email = emails[i];
        emailStatus[email] = {status: null}
      }

      state.emailStatus = emailStatus
    },

    resetEmailStatus: (state, action) => {
      state.emailStatus = null
    },

    emailSuccess: (state, action) => {
      // state.emailStatus =Object.values(action.payload)[0].status
      state.emailStatus = action.payload
    },

    emailFailure: (state, action) => {
      let emailStatusCopy = _.cloneDeep(state.emailStatus)
      let emailStatusKeys = Object.keys(emailStatusCopy)
      // NOTE // if the email request fails, set the status of each email to false (for failure)
      for (let i = 0; i < emailStatusKeys.length; i++) {
        emailStatusCopy[emailStatusKeys[i]].status = false
      }
      state.emailStatus = emailStatusCopy
    },

    sendItinStart: (state, action) => {
      state.emailStatus = 'loading'
    },

    sendItinSuccess: (state, action) => {
      state.emailStatus = action.payload
    },

    sendItinFailure: (state, action) => {
      state.emailStatus = 'error'
    },

    emailHistorySuccess: (state, action) => {
      state.emailHistory = action.payload
    },

    emailHistoryFailure: (state, action) => {
      console.log('emailHist error: ', action.payload)
    },

    // !SECTION
    // SECTION baggage
    setCurBagLoc: (state, action) => {
      // NOTE // sets the departure and passenger keys for addNewBag
      state.curBagDep = action.payload.dep
      state.curBagPax = action.payload.pax
    },

    addNewBag: (state, action) => {
      // NOTE // the selected departure
      let curDep = _.cloneDeep(state.curBagDep)
      // NOTE // the selected passenger
      let curPax = _.cloneDeep(state.curBagPax)
      // NOTE // the departures list
      let paxInfoCopy = _.cloneDeep(state.paxInfo)

      let depLoc = paxInfoCopy.findIndex((dep) => dep.key == curDep.key)
      // let paxLoc = paxInfoCopy[depLoc].passengers.findIndex((pax) => )

      // NOTE // find the passenger and add the new bag
      for (let i = 0; i < paxInfoCopy.length; i++) {
        const dep = paxInfoCopy[i];
        if (dep.passengers && dep.key == curDep.key) {
          for (let j = 0; j < dep.passengers.length; j++) {
            const pax = dep.passengers[j];
            let paxName = curPax.name.toUpperCase()
            let matchingName = paxName.includes(pax.profile.firstName) && paxName.includes(pax.profile.lastName)
            let matchingBirth = pax.profile.birthDate == curPax.dob
            let matchingRloc = pax.reservation.locator == curPax.rloc
            let isMatch = matchingName && matchingBirth && matchingRloc
            if (curPax.key == pax.key || isMatch) {
              paxInfoCopy[i].passengers[j].passengerJourneyDetail.bags ?
              state.paxInfo[i].passengers[j].passengerJourneyDetail.bags.push(action.payload[0]) :
              state.paxInfo[i].passengers[j].passengerJourneyDetail.bags = action.payload
            }
          }
        }
      }
    },

    postBagFailed: (state, action) => {
      console.log('ERR: POST BAG FAILED')
    },

    replaceBag: (state, action) => {
      let paxInfoCopy = _.cloneDeep(state.paxInfo)
      let bagKey = action.payload.key

      for (let i = 0; i < paxInfoCopy.length; i++) {
        const dep = paxInfoCopy[i];
        for (let j = 0; j < dep.passengers.length; j++) {
          const pax = dep.passengers[j];
          for (let k = 0; k < pax.passengerJourneyDetail.bags.length; k++) {
            const bag = pax.passengerJourneyDetail.bags[k];
            if (bagKey == bag.key) {
              state.paxInfo[i].passengerJourneyDetail.bags[k] = action.payload
            }
          }
        }
      }
    },

    updateBagFailed: (state, action) => {
      console.log('ERR: UPDATE BAG FAILED')
    },

    setBagToDelete: (state, action) => {
      state.bagToDelete = action.payload
    },

    removeBag: (state, action) => {
      let paxInfoCopy = _.cloneDeep(state.paxInfo)

      for (let i = 0; i < paxInfoCopy.length; i++) {
        const dep = paxInfoCopy[i];
        if (dep.passengers) {
          for (let j = 0; j < dep.passengers.length; j++) {
            const pax = dep.passengers[j];
            let bags = pax.passengerJourneyDetail.bags
            let bagLoc = -1
            if (bags) {
              bagLoc = bags.findIndex(b => b.key == state.bagToDelete.key)
            }
            if (bagLoc != -1) {
              state.paxInfo[i].passengers[j].passengerJourneyDetail.bags.splice(bagLoc, 1)
            }
          }
        }
      }
    },

    deleteBagFailed: (state, action) => {
      console.log('ERR: DELETE BAG FAILED')
    },

    // !SECTION
  }
})

const {  departuresReceived, departuresRequested, departuresRequestFailed,  paxInfoReceived,  paxInfoRequested,  paxInfoRequestFailed, clearPaxInfo, updatePaxInfoFailed,  paxUpdated, legStatusReceived, loadStatusFailed, flightClosed, flightCloseFailed, sendingMessage, messageSent, messageFailed, emailSuccess, emailFailure, textSuccess, textFailure, addNewBag, postBagFailed, replaceBag, updateBagFailed, removeBag, deleteBagFailed, emailHistorySuccess, emailHistoryFailure, sendItinStart, sendItinSuccess, sendItinFailure
} = slice.actions;

export const { setAirline, historyFailure,reservationInfoReceived, historyFetching, historyReceived,emailHistoryReceived, startSendText, sendTextFailure, sendTextSuccess, changeDepartureDate, changeAirport, changeDeparture, changeFlight, doneSendingMessage, setCurBagLoc, setBagToDelete, setEmailStatus, resetEmailStatus, setTextStatus, resetTextStatus, resetTextHistory, resetEmailHistory } = slice.actions;
export default slice.reducer;

// Action Creators
// const url = `/departures?earliestDeparture=${startDate}&latestDeparture=${endDate}`;

export const loadDepartures = (departureDate, departureAirport, loadPax) => (dispatch, getState) => {
  const flightNum = getState().entities.departures.flightNumber
  const url = `/departures?_end=10&_order=ASC&_sort=id&_start=0&departure=${departureDate}${flightNum ? ('&flightNumber=' + flightNum) : ''}&departureAirport=${departureAirport ? departureAirport : ''}`;

  // NOTE // need to clear paxInfo when changing dates/loading departures.
  dispatch(clearPaxInfo())

 

  return dispatch(
    apiCallBegan({
      url,
      onStart: departuresRequested.type,
      onSuccess: departuresReceived.type,
      onError: departuresRequestFailed.type,
    })
  )
}

export const loadPaxInfo = (key) => (dispatch, getState) => {
  const url = `/departures/${key}`;

  return dispatch(
    apiCallBegan({
      url,
      onStart: paxInfoRequested.type,
      onSuccess: paxInfoReceived.type,
      onError: paxInfoRequestFailed.type
    })
  )
}






export const updatePax = (tailItem, key, jkey, output) => (dispatch, getState) => {
  let url = `departures/${tailItem.key}/passengers/${key}/passengerJourneyDetail/${jkey}`

  return dispatch(
    apiCallBegan({
      url,
      method: 'put',
      data: output,
      onSuccess: paxUpdated.type,
      onError: updatePaxInfoFailed.type
    })
  )
}

// // NOTE // takes in an array of objects containing the keys to generate the urls, and the replacement data
export const updateMultiplePax = (paxArray, cfInfo) => (dispatch, getState) => {
  let url = []
  let output = []
  for (let i = 0; i < paxArray.length; i++) {
    const pax = paxArray[i];
    // NOTE // formats the url using the departure, passenger, and passengerJourneyDetail keys
    url.push(`departures/${pax.depKey}/passengers/${pax.pasKey}/passengerJourneyDetail/${pax.jKey}`)
    output.push(pax.output)
  }

  return dispatch(
    apiCallBegan({
      url,
      method: 'put',
      data: output,
      followUpData: cfInfo,
      onSuccess: paxUpdated.type,
      onError: updatePaxInfoFailed.type,
      onFollowUp: 'closeFlight',
    })
  )
}

export const closeFlight = (statusKey, legKey, output) => (dispatch, getState) => {
  let url = `flightStatuses/${statusKey}/legs/${legKey}`

  return dispatch(
    apiCallBegan({
      url,
      method: 'put',
      data: output,
      onSuccess: flightClosed.type,
      onError: flightCloseFailed.type,
    })
  )
}

export const flightTextHistory = (date, flightNumber) => (dispatch, getState) => {
  const url = `sms-history`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      base: 'fred',
      data: {date, flightNumber, airline_id: flightNumber.substring(0, 2)},
      onStart: historyFetching.type,
      onSuccess: historyReceived.type,
      onError: historyFailure.type,
    })
  )
}

export const individualTextHistory = (phoneNumber) => (dispatch, getState) => {
  const url = `sms-history/individual`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      base: 'fred',
      data: {phoneNumber},
      onStart: historyFetching.type,
      onSuccess: historyReceived.type,
      onError: historyFailure.type,
    })
  )
}

export const individualEmailHistory = ({email, rloc}) => (dispatch, getState) => {
  const url = `emailPax/history`
  console.log(email,rloc)
  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      base: 'fred',
      data: {email, rloc},
      onSuccess: emailHistoryReceived.type,
      onError: historyFailure.type,
    })
  )
}

export const allEmailHistory = ({rloc, timestamp}) => (dispatch, getState) => {
  const url = `emailPax/all`
  console.log(rloc, timestamp)
  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      base: 'fred',
      data: {rloc,timestamp},
      onSuccess: emailHistoryReceived.type,
      onError: historyFailure.type,
    })
  )
}

export const textPax = (message, flightNum, recipients, date) => (dispatch, getState) => {
  const url = `sms/send`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      base: 'fred',
      data: { message: message, flightNumber: flightNum, passengers: recipients, airlineId: 'AN', departureDate: date },
      onStart: startSendText.type,
      onSuccess: sendTextSuccess.type,
      onError: sendTextFailure.type,
    })
  )
}

// NOTE // I don't think this is being used, Idk what I was doing with this
export const loadLegStatus = (statusKey, legKey) => (dispatch, getState) => {
  let url = `flightStatuses/${statusKey}/legs/${legKey}`
  
  return dispatch(
    apiCallBegan({
      url,
      method: 'get',
      onSuccess: legStatusReceived.type,
      onError: loadStatusFailed.type,
    })
  )
}

export const sendText = (message, flightNum, recipients, date) => (dispatch, getState) => {
  const url = `sms/send`
  let base = 'fred'

  return dispatch(
    apiCallBegan({
      base,
      url,
      method: 'post',
      data: { message: message, flightNumber: flightNum, passengers: recipients, airlineId: 'AN', departureDate: date },
      onSuccess: textSuccess.type,
      onError: textFailure.type
    })
  )
}

export const sendEmail = (emails,flightNum, templateId, subData) => (dispatch, getState) => {
  let url = `emailPax`
  let base = 'fred'

  return dispatch(
    apiCallBegan({
      base,
      url,
      method: 'post',
      data: { emails: emails, airlineId: 'AN', templateId: templateId, subData: subData, rloc:flightNum },
      onSuccess: emailSuccess.type,
      onError: emailFailure.type
    })
  )
}

export const sendItinerary = (rlocs, customEmail) => (dispatch, getState) => {
  let url = 'sendPaxItin'
  let base = 'fred'

  // sendItinStart, sendItinSuccess, sendItinFailure

  return dispatch(
    apiCallBegan({
      base,
      url,
      method: 'post',
      data: {rlocs: rlocs, customEmail: customEmail},
      onStart: sendItinStart.type,
      onSuccess: sendItinSuccess.type,
      onError: sendItinFailure.type
    })
  )
}

export const getEmailHistory = (date) => (dispatch, getState) => {
  let url = `emailPax/history`
  let base = `fred`

  return dispatch(
    apiCallBegan({
      base,
      url,
      method: 'post',
      data: { date: date, tzOffset: new Date().getTimezoneOffset() },
      onSuccess: emailHistorySuccess.type,
      onError: emailHistoryFailure.type
    })
  )
}

export const updateBag = (depKey, pKey, pjdKey, bagKey, output) => (dispatch, getState) => {
  let url = `departures/${depKey}/passengers/${pKey}/passengerJourneyDetail/${pjdKey}/bags/${bagKey}`

  return dispatch(
    apiCallBegan({
      url,
      method: 'put',
      data: output,
      onSuccess: replaceBag.type,
      onError: updateBagFailed.type
    })
  )
}

export const postBag = (depKey, pKey, pjdKey, output) => (dispatch, getState) => {
  // NOTE // doc url: POST departures/{key}/passengers/{passengerKey}/passengerJourneyDetail/{passengerJourneyDetailKey}/bags 
  let url = `departures/${depKey}/passengers/${pKey}/passengerJourneyDetail/${pjdKey}/bags`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: output,
      onSuccess: addNewBag.type,
      onError: postBagFailed.type
    })
  )
}

export const deleteBag = (depKey, pKey, pjdKey, bagKey) => (dispatch, getState) => {
  // NOTE // doc url: DELETE departures/ {key} /passengers/ {passengerKey} /passengerJourneyDetail/ {passengerJourneyDetailKey} /bags/ {bagKey}
  let url = `departures/${depKey}/passengers/${pKey}/passengerJourneyDetail/${pjdKey}/bags/${bagKey}`

  return dispatch(
    apiCallBegan({
      url,
      method: 'delete',
      onSuccess: removeBag.type,
      onError: deleteBagFailed.type
    })
  )
}